/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmergenzaAssistitoAddByFilterDTO,
  EmergenzaAssistitoDTO,
  EmergenzaAssistitoUpdateDTO,
  EmergenzaCreateDTO,
  EmergenzaDTO,
  EmergenzaNonAllocatiDTO,
  EmergenzaUpdateDTO,
  ProblemDetails,
} from '../models/index';
import {
    EmergenzaAssistitoAddByFilterDTOFromJSON,
    EmergenzaAssistitoAddByFilterDTOToJSON,
    EmergenzaAssistitoDTOFromJSON,
    EmergenzaAssistitoDTOToJSON,
    EmergenzaAssistitoUpdateDTOFromJSON,
    EmergenzaAssistitoUpdateDTOToJSON,
    EmergenzaCreateDTOFromJSON,
    EmergenzaCreateDTOToJSON,
    EmergenzaDTOFromJSON,
    EmergenzaDTOToJSON,
    EmergenzaNonAllocatiDTOFromJSON,
    EmergenzaNonAllocatiDTOToJSON,
    EmergenzaUpdateDTOFromJSON,
    EmergenzaUpdateDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface AddEmergenzaAssistitiByFilterRequest {
    tenantId: string;
    emergenzaId: string;
    emergenzaAssistitoAddByFilterDTO?: EmergenzaAssistitoAddByFilterDTO;
}

export interface CloseCurrentEmergenzaRequest {
    tenantId: string;
}

export interface DeleteEmergenzaRequest {
    emergenzaId: string;
    tenantId: string;
}

export interface DeleteEmergenzaAssistitoRequest {
    emergenzaAssistitoId: string;
    tenantId: string;
    emergenzaId: string;
}

export interface GetAssistitiNonAllocatiRequest {
    tenantId: string;
}

export interface GetCurrentEmergenzaRequest {
    tenantId: string;
}

export interface GetCurrentEmergenzaAssistitiByCurrentOperatoreRequest {
    tenantId: string;
    visualizzaTutti?: boolean;
}

export interface GetCurrentEmergenzaAssistitoByIdRequest {
    emergenzaAssistitoId: string;
    tenantId: string;
}

export interface GetCurrentReportRequest {
    tenantId: string;
}

export interface GetEmergenzaAssistitiRequest {
    emergenzaId: string;
    tenantId: string;
}

export interface GetEmergenzaByIdRequest {
    emergenzaId: string;
    tenantId: string;
}

export interface GetEmergenzeRequest {
    tenantId: string;
}

export interface InsertEmergenzaRequest {
    tenantId: string;
    emergenzaCreateDTO?: EmergenzaCreateDTO;
}

export interface UpdateEmergenzaRequest {
    emergenzaId: string;
    tenantId: string;
    emergenzaUpdateDTO?: EmergenzaUpdateDTO;
}

export interface UpdateEmergenzaAssistitiRequest {
    emergenzaAssistitoId: string;
    tenantId: string;
    emergenzaId: string;
    emergenzaAssistitoUpdateDTO?: EmergenzaAssistitoUpdateDTO;
}

/**
 * 
 */
export class EmergenzeApi extends runtime.BaseAPI {

    /**
     */
    async addEmergenzaAssistitiByFilterRaw(requestParameters: AddEmergenzaAssistitiByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling addEmergenzaAssistitiByFilter().'
            );
        }

        if (requestParameters['emergenzaId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaId',
                'Required parameter "emergenzaId" was null or undefined when calling addEmergenzaAssistitiByFilter().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/{emergenzaId}/Assistiti/ByFilter`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))).replace(`{${"emergenzaId"}}`, encodeURIComponent(String(requestParameters['emergenzaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmergenzaAssistitoAddByFilterDTOToJSON(requestParameters['emergenzaAssistitoAddByFilterDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async addEmergenzaAssistitiByFilter(requestParameters: AddEmergenzaAssistitiByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.addEmergenzaAssistitiByFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async closeCurrentEmergenzaRaw(requestParameters: CloseCurrentEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling closeCurrentEmergenza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/Current/Close`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async closeCurrentEmergenza(requestParameters: CloseCurrentEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.closeCurrentEmergenzaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteEmergenzaRaw(requestParameters: DeleteEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['emergenzaId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaId',
                'Required parameter "emergenzaId" was null or undefined when calling deleteEmergenza().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteEmergenza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/{emergenzaId}`.replace(`{${"emergenzaId"}}`, encodeURIComponent(String(requestParameters['emergenzaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteEmergenza(requestParameters: DeleteEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEmergenzaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteEmergenzaAssistitoRaw(requestParameters: DeleteEmergenzaAssistitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['emergenzaAssistitoId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaAssistitoId',
                'Required parameter "emergenzaAssistitoId" was null or undefined when calling deleteEmergenzaAssistito().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteEmergenzaAssistito().'
            );
        }

        if (requestParameters['emergenzaId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaId',
                'Required parameter "emergenzaId" was null or undefined when calling deleteEmergenzaAssistito().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/{emergenzaId}/Assistiti/{emergenzaAssistitoId}`.replace(`{${"emergenzaAssistitoId"}}`, encodeURIComponent(String(requestParameters['emergenzaAssistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))).replace(`{${"emergenzaId"}}`, encodeURIComponent(String(requestParameters['emergenzaId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteEmergenzaAssistito(requestParameters: DeleteEmergenzaAssistitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEmergenzaAssistitoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAssistitiNonAllocatiRaw(requestParameters: GetAssistitiNonAllocatiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergenzaNonAllocatiDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitiNonAllocati().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/Current/AssistitiNonAllocati`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergenzaNonAllocatiDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitiNonAllocati(requestParameters: GetAssistitiNonAllocatiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergenzaNonAllocatiDTO> {
        const response = await this.getAssistitiNonAllocatiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCurrentEmergenzaRaw(requestParameters: GetCurrentEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergenzaDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getCurrentEmergenza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/Current`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergenzaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getCurrentEmergenza(requestParameters: GetCurrentEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergenzaDTO | null | undefined > {
        const response = await this.getCurrentEmergenzaRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     */
    async getCurrentEmergenzaAssistitiByCurrentOperatoreRaw(requestParameters: GetCurrentEmergenzaAssistitiByCurrentOperatoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmergenzaAssistitoDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getCurrentEmergenzaAssistitiByCurrentOperatore().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['visualizzaTutti'] != null) {
            queryParameters['visualizzaTutti'] = requestParameters['visualizzaTutti'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/Current/Assistiti/ByCurrentOperatore`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmergenzaAssistitoDTOFromJSON));
    }

    /**
     */
    async getCurrentEmergenzaAssistitiByCurrentOperatore(requestParameters: GetCurrentEmergenzaAssistitiByCurrentOperatoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmergenzaAssistitoDTO>> {
        const response = await this.getCurrentEmergenzaAssistitiByCurrentOperatoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCurrentEmergenzaAssistitoByIdRaw(requestParameters: GetCurrentEmergenzaAssistitoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergenzaAssistitoDTO>> {
        if (requestParameters['emergenzaAssistitoId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaAssistitoId',
                'Required parameter "emergenzaAssistitoId" was null or undefined when calling getCurrentEmergenzaAssistitoById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getCurrentEmergenzaAssistitoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/Current/Assistiti/{emergenzaAssistitoId}`.replace(`{${"emergenzaAssistitoId"}}`, encodeURIComponent(String(requestParameters['emergenzaAssistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergenzaAssistitoDTOFromJSON(jsonValue));
    }

    /**
     */
    async getCurrentEmergenzaAssistitoById(requestParameters: GetCurrentEmergenzaAssistitoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergenzaAssistitoDTO> {
        const response = await this.getCurrentEmergenzaAssistitoByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCurrentReportRaw(requestParameters: GetCurrentReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getCurrentReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/Current/Report`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getCurrentReport(requestParameters: GetCurrentReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getCurrentReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmergenzaAssistitiRaw(requestParameters: GetEmergenzaAssistitiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmergenzaAssistitoDTO>>> {
        if (requestParameters['emergenzaId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaId',
                'Required parameter "emergenzaId" was null or undefined when calling getEmergenzaAssistiti().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getEmergenzaAssistiti().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/{emergenzaId}/Assistiti`.replace(`{${"emergenzaId"}}`, encodeURIComponent(String(requestParameters['emergenzaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmergenzaAssistitoDTOFromJSON));
    }

    /**
     */
    async getEmergenzaAssistiti(requestParameters: GetEmergenzaAssistitiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmergenzaAssistitoDTO>> {
        const response = await this.getEmergenzaAssistitiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmergenzaByIdRaw(requestParameters: GetEmergenzaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergenzaDTO>> {
        if (requestParameters['emergenzaId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaId',
                'Required parameter "emergenzaId" was null or undefined when calling getEmergenzaById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getEmergenzaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/{emergenzaId}`.replace(`{${"emergenzaId"}}`, encodeURIComponent(String(requestParameters['emergenzaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergenzaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getEmergenzaById(requestParameters: GetEmergenzaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergenzaDTO> {
        const response = await this.getEmergenzaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmergenzeRaw(requestParameters: GetEmergenzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmergenzaDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getEmergenze().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmergenzaDTOFromJSON));
    }

    /**
     */
    async getEmergenze(requestParameters: GetEmergenzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmergenzaDTO>> {
        const response = await this.getEmergenzeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertEmergenzaRaw(requestParameters: InsertEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergenzaDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertEmergenza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmergenzaCreateDTOToJSON(requestParameters['emergenzaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergenzaDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertEmergenza(requestParameters: InsertEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergenzaDTO> {
        const response = await this.insertEmergenzaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateEmergenzaRaw(requestParameters: UpdateEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['emergenzaId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaId',
                'Required parameter "emergenzaId" was null or undefined when calling updateEmergenza().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateEmergenza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/{emergenzaId}`.replace(`{${"emergenzaId"}}`, encodeURIComponent(String(requestParameters['emergenzaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmergenzaUpdateDTOToJSON(requestParameters['emergenzaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateEmergenza(requestParameters: UpdateEmergenzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEmergenzaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateEmergenzaAssistitiRaw(requestParameters: UpdateEmergenzaAssistitiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['emergenzaAssistitoId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaAssistitoId',
                'Required parameter "emergenzaAssistitoId" was null or undefined when calling updateEmergenzaAssistiti().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateEmergenzaAssistiti().'
            );
        }

        if (requestParameters['emergenzaId'] == null) {
            throw new runtime.RequiredError(
                'emergenzaId',
                'Required parameter "emergenzaId" was null or undefined when calling updateEmergenzaAssistiti().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Emergenze/{emergenzaId}/Assistiti/{emergenzaAssistitoId}`.replace(`{${"emergenzaAssistitoId"}}`, encodeURIComponent(String(requestParameters['emergenzaAssistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))).replace(`{${"emergenzaId"}}`, encodeURIComponent(String(requestParameters['emergenzaId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmergenzaAssistitoUpdateDTOToJSON(requestParameters['emergenzaAssistitoUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateEmergenzaAssistiti(requestParameters: UpdateEmergenzaAssistitiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEmergenzaAssistitiRaw(requestParameters, initOverrides);
    }

}
